<div *ngIf="extendedServiceTimes$ | async as extendedServiceTimes; else loading" class="layout-column gap-5">
  <div class="layout-row layout-align-start-center gap-5">
    <span class="font-weight-600" translate>Previous Week</span>
    <span>{{ extendedServiceTimes.previousProjectServiceTime | bringozTimeHHMM }}</span>
  </div>
  <div class="layout-row layout-align-start-center gap-5">
    <span class="font-weight-600" translate>Next Week</span>
    <span>{{ extendedServiceTimes.nextProjectServiceTime | bringozTimeHHMM }}</span>
  </div>
</div>

<ng-template #loading>
  <div class="layout-row layout-align-center-center">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
</ng-template>
